import { ContactUsHeader, ContactUsInfo } from "../components";

export function ContactUsPage() {
  return (
    <>
      <ContactUsHeader />
      <ContactUsInfo />
    </>
  );
}
